import { Component } from '@angular/core';
import { BasicList } from '../../../../classes';
import { BsModalService } from 'ngx-bootstrap';
import * as moment from 'moment';
import { ProductsService } from '../../../../services';
import { DiscountApi } from '../../../../../assets/js/lb-sdk/services/custom/Discount';
import { AgentProfileComponent } from '../../../agents/agent-profile/agent-profile.component';
import { DiscountRateFormComponent } from './discount-rate-form/discount-rate-form.component';
import { LoopBackAuth } from '../../../../../assets/js/lb-sdk';
import { USER_ROLES } from '../../../../enums';
import { Event } from '../../../../interfaces';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-discount-rates',
  templateUrl: './discount-rates.component.html',
  styleUrls: ['./discount-rates.component.css']
})
export class DiscountRatesComponent extends BasicList {
  moment = moment;
  USER_ROLES : typeof USER_ROLES = USER_ROLES;

  constructor(
    private discountApi: DiscountApi,
    private modalService: BsModalService,
    private productsService: ProductsService,
    private loopBackAuth: LoopBackAuth,
    private toast: ToastrService
  ) {
    super();
    this.searchSettings = {
      searchFields: [],
      searchableFields: [
        { name: 'merchantId', placeholder: 'Merchant id', exact: true }
      ],
      filters: {}
    };
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.settings = {
      createComponent: DiscountRateFormComponent,
      api: this.discountApi,
      ModalService: this.modalService,
      delete: {
        method: this.deleteMethod.bind(this)
      }
    };
  }

  modify(data) {
    const { creditTerms, endDate, merchantId, merchantType, paymentType, productType, rate, unit } = data;
    const endDateMoment = moment(endDate,'YYYYMMDD').toDate();
    this.edit({
      creditTerms,
      endDate: { date: {
        year: endDateMoment.getFullYear(),
        month: endDateMoment.getMonth() + 1,
        day: endDateMoment.getDate()
      } },
      merchantId,
      merchantType: merchantType,
      paymentType: paymentType,
      productType: this.productsService.getProductTypeByName(productType),
      rate,
      unit
    });
  }

  userDetails(data): void {
    const userModal = this.settings.ModalService
      .show(AgentProfileComponent, {
        initialState: { data: { merchantId: data.merchantId } }
      });
    const subscription = this.modalService.onHidden
      .subscribe(() => {
        if (userModal.content) {
          if (userModal.content.result) {
            // DO SOMETHING
          } else {
            // DO SOMETHING
          }
        }
        subscription.unsubscribe();
      });
  }

  deleteMethod(data) {
    return this.discountApi.delete(data.merchantId, data.productType, data.endDate);
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }

  eventListener(event: Event) {
    switch (event.event) {
      case 'createModal:completed':
        this.toast.success('Discount rate successfully created', 'Discount Rate');
        this.getList();
        break;
      case 'editModal:completed':
        this.toast.success('Discount rate successfully updated', 'Discount Rate');
        this.getList();
        break;
      case 'delete:success':
        this.toast.success('Discount rate successfully deleted', 'Discount Rate');
        this.getList();
        break;
      case 'initialized':
        this.getList();
        break;
    }
  }
}
